export enum EnumBloqueoCapacidad {
  BloqueadoBundle = 1,
  BloqueadoUsuario = 2,
  Libre = 3,
  BloqueadoTemporal = 99 /* Custom value not implemented in API for locking temporarily while simulating allocation */
}
